import React, { Component } from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

import Dashboard from '../Dashboard/Dashboard';
import FtueController from '../Ftue/FtueController';
import FtueSceneRunner from '../Ftue/FtueSceneRunner';
import Lobby from '../Menus/Lobby/Lobby';
import { QuickRouter } from '../TwoD/QuickRouter';

import './game-component.css';


class GameComponent extends Component {

    constructor(props) {
        super(props);
        this.app = this.props.app;
        this.app.gameComponent = this;
        this.state = {
            gameData: null,
            gamePlayerData: null,
            routeToGame: null
        }
        this.quickRouter = null;
    }

    componentDidMount() {
        // 2026-05-14: React 19 StrictMode dev double-invokes the
        // mount cycle on the SAME instance: mount → unmount →
        // mount. componentWillUnmount clears app.gameComponent to
        // null, so by the time the second componentDidMount fires
        // (and certainly by the first re-render after that),
        // anything that reads this.app.gameComponent.X null-derefs.
        // Re-anchor the global reference here so the second mount
        // restores it.
        this.app.gameComponent = this;
        // 2026-05-15: Always-on escape hatch. Esc returns to /play
        // via QuickRouter, regardless of game status. The earlier
        // attempt routed through menuController.changeToMenu which
        // doesn't survive a Game Over state.
        this.hookKeys();
        if (this.props.params.gameId) {
            let gameId = this.props.params.gameId;
            if (gameId === 'simulation') {
                this.props.app.game.gameApi.getSimulation();
            } else if (!this.state.gameData || this.state.gameData.id !== gameId) {
                this.props.app.game.gameApi.getGame(gameId);
            }
        } else {
            this.props.app.game.gameApi.resumeGame();
        }
        window.addEventListener('game-event', this.gameEvent);
        window.addEventListener('seated-game-player-event', this.seatedGamePlayerEvent);
        this.props.app.game.groupHandler.firstTimeGroupFetch();
    }

    componentWillUnmount() {
        this.app.gameComponent = null;
        window.removeEventListener('keydown', this.keydown);
        window.removeEventListener('game-event', this.gameEvent);
        window.removeEventListener('seated-game-player-event', this.seatedGamePlayerEvent);
    }

    gameEvent = (e) => {
        this.loadGame(e.detail)
    }

    seatedGamePlayerEvent = (e) => {
        this.setState({ gamePlayerData: e.detail },
            this.setSeatURLSearchParameter);
    }

    hookKeys = () => {
        window.addEventListener('keydown', this.keydown);
    }

    keydown = (keyboardEvent) => {
        let key = keyboardEvent.key;
        if (key === 'Escape') {
            // Unconditional escape — fires whether the game is mid-turn,
            // in a stuck modal, or fully Game Over. QuickRouter is
            // mounted as a sibling and listens for this event.
            window.dispatchEvent(
                new CustomEvent('quick-router-event', { detail: '/play' }));
        }
    }

    loadGame = (gameData) => {
        // If this is a different game, route the URL to that game ID.
        if (this.state.gameData !== null && this.state.gameData.id === gameData.id) {
            this.setState({gameData: gameData});
        } else {
            this.setState({gameData: gameData, routeToGame: null}, () => {
                let gameId = parseInt(this.props.params.gameId);
                if (gameId !== gameData.id) {
                    this.setState({routeToGame: gameData.id}, () => {
                        this.setState({routeToGame: null})
                    })
                }
            });
        }
    }

    loadGamePlayer = (gamePlayerData) => {
        // try and skip this.....
        this.setState({ gamePlayerData: gamePlayerData },
            this.setSeatURLSearchParameter);
    };

    loadGameAndGamePlayer = (gameData, gamePlayerData) => {
        this.setState({
            gameData: gameData,
            gamePlayerData: gamePlayerData }
        );
    }

    setSeatURLSearchParameter = () => {
        // this.app.gameComponent === this on this instance, but reading
        // through the global is brittle under React 19 StrictMode (see
        // componentDidMount comment). Use `this` directly.
        //
        // CC_FE_PAGES_TIGHTEN (2026-06-01): when the seat arrives as a
        // `seat` prop (GamePage's /game/:lobbyUuid flow passes no
        // searchParams), never write it back to the URL — only the legacy
        // URL-driven mount owns the query param.
        if (this.props.seat != null || !this.props.searchParams) return;
        let searchParams = this.props.searchParams[0];
        let setSearchParams = this.props.searchParams[1];
        let seat = searchParams.get('seat');
        if (this.state.gamePlayerData && (
            seat === null || (seat !== this.state.gamePlayerData.seat))) {
            searchParams.set('seat', this.state.gamePlayerData.seat);
            setSearchParams(searchParams);
        }
    }

    clearSeatURLSearchParameter = () => {
        let searchParams = this.props.searchParams[0];
        let setSearchParams = this.props.searchParams[1];
        searchParams.delete('seat');
        setSearchParams(searchParams);
    }

    sitCheck = () => {
        // check if valid seat here before sending?
        if (this.state.gameData && !this.state.gamePlayerData) {
            // CC_FE_PAGES_TIGHTEN (2026-06-01): a finite `seat` prop
            // (GamePage's /game/:lobbyUuid flow) takes precedence over the
            // legacy URL ?seat= read.
            let seat = Number.isInteger(this.props.seat)
                ? this.props.seat
                : (this.props.searchParams
                    ? parseInt(this.props.searchParams[0].get('seat'), 10)
                    : NaN);
            if (Number.isInteger(seat)) {
                window.dispatchEvent(new CustomEvent('take-seat-event', { detail: seat }));
                return true;
            }
        }
        return false;
    }

    render() {
        // console.log('GameComponent.render', this.props, this.state);
        // if (this.state.routeToGame) {
        //     return <Navigate to={`/game/${this.state.routeToGame}/`}/>;
        // }
        this.sitCheck();
        let show2d = false;
        if (this.props.params.gameId) {
            show2d = true;
        }

        let gamePlayerData = this.state.gamePlayerData;
        let isActivePlayer = (
            gamePlayerData ?
                this.state.gameData.active_player === gamePlayerData.id :
                false);

        let props = {
            ...this.props,
            gameData: this.state.gameData,
            gamePlayerData: this.state.gamePlayerData,
            isActivePlayer: isActivePlayer
        }

        // CC_LOBBY: the new unified Lobby renders during the transient
        // pre-start window (Game.status 15 LOBBY or 16 OPEN). Once
        // launch_group flips status to STARTED, this falls through to
        // the regular in-game UI. Post-CC_LOBBY the LOBBY/OPEN window
        // is rarely seen because launch_group transitions immediately;
        // the gate is here for resumed-game safety.
        let preGameStart = false;
        if (this.state.gameData) {
            preGameStart = (
                this.state.gameData.status === 15
                || this.state.gameData.status === 16);
        }

        return <div id={'GameComponent'} className={'game-component'} >
            <QuickRouter ref={ref => this.quickRouter = ref} />
            {
                this.state.routeToGame && <Navigate to={`/game/${this.state.routeToGame}/`}/>
            }
            <Dashboard {...props}/>
            {preGameStart && <Lobby {...props} />}
            {/* <Transcripts {...props} /> */}
            <FtueController {...props} />
            <FtueSceneRunner {...props} />
        </div>;
    }
}

// CC_FE_PAGES (2026-06-01): the inner class is exported (additively —
// no logic/render change) so the /game/:lobbyUuid wrapper (GamePage) can
// mount it with a synthetic `params={{gameId: <int>}}` instead of the
// URL-derived param. GameComponent reads its id only off
// `params.gameId` and self-navigates on a mismatch, so it cannot be
// mounted naively under a uuid route. Mirrors the App.js:32 pattern of
// re-exporting a component for composition. The default export below
// (the useParams-driven wrapper) is unchanged.
export { GameComponent };

export default (props) => {
    let params = useParams();
    const searchParams = useSearchParams();
    let location = useLocation();
    return <GameComponent {...props}
                          params={params}
                          location={location}
                          searchParams={searchParams}/>
}
